module.exports = __webpack_public_path__ + "static/media/aogmm.77cb00e1.jpeg";